import React, { Component } from 'react';
import Helmet from 'react-helmet';
import { Query } from 'react-apollo';
import { Heading1 } from 'localmed-core';

import style from './AppointmentDetailPage.scss';

import { Redirect } from '../../../_universal';
import LegacyPanel from '../../../legacyCore/LegacyPanel';
import StaticMap from '../../../legacyCore/StaticMap';
import AppointmentInstructions from '../../../shared/components/AppointmentDetail/AppointmentInstructions';
import { appointmentQuery } from '../../../shared/components/AppointmentDetail/queries';
import AppointmentInfo from '../../../shared/components/AppointmentInfo';
import Unauthorized from '../../../shared/components/Unauthorized';
import { createSchedulingSessionStateLandingPage } from '../../../shared/components/SchedulingSessionState';
import { FLASH_MESSAGES } from '../../../shared/constants';

import { isUnavailable } from '../../../shared/utils/appointmentUtils';
import isForbidden from '../../../shared/utils/isForbidden';
import { buildRescheduleUrl, getQueryFromLocation } from '../../../shared/utils/urls';
import MainLayout from '../../components/MainLayout/MainLayoutWithData';
import LoadingPage from '../LoadingPage';
import NotFoundPage from '../NotFoundPage';

class AppointmentDetailPage extends Component {
  render() {
    const {
      match: { params },
      history: { location },
    } = this.props;
    const query = getQueryFromLocation(location);
    return (
      <Query query={appointmentQuery} variables={{ id: params.id, patientToken: query.token }}>
        {({ loading, error, data }) => {
          if (loading) return <LoadingPage />;
          if (isForbidden(error))
            return (
              <Unauthorized>
                <LoadingPage />
              </Unauthorized>
            );
          if (error) return <MainLayout error={error} />;
          if (!data || !data.appointment) return <NotFoundPage />;

          const { appointment } = data;
          if (isUnavailable(appointment)) {
            const rescheduleUrl = buildRescheduleUrl(appointment.id, {
              patientToken: appointment.patientToken,
              useMainLayout: true,
            });
            return (
              <Redirect to={rescheduleUrl}>
                <LoadingPage />
              </Redirect>
            );
          }

          return (
            <MainLayout>
              <Helmet>
                <title>
                  {appointment.patientName}
                  ’s Appointment
                </title>
                <meta name="robots" content="noindex" />
              </Helmet>
              <div className={style['appointment-form-page__row']}>
                <div className={style['appointment-form-page__main']}>
                  <Heading1
                    fontWeight="bold"
                    lineHeight="solid"
                    marginTop="md"
                    marginBottom={{ _: 'sm', md: 'md' }}
                    className={style['appointment-form-page__title']}
                  >
                    {`${appointment.patientName}’s Appointment`}
                    <br />
                    <small>with {appointment.provider.display}</small>
                  </Heading1>
                  <LegacyPanel size="lg" mb={0}>
                    <AppointmentInstructions
                      justScheduled={query.message === FLASH_MESSAGES.SCHEDULED}
                      justConfirmed={query.message === FLASH_MESSAGES.CONFIRMED}
                      appointment={appointment}
                    />
                  </LegacyPanel>
                </div>

                <div className={style['appointment-form-page__aside']}>
                  <StaticMap
                    className={style['appointment-form-page__map']}
                    width="100%"
                    height="192"
                    zoom={12}
                    markers={[
                      {
                        latitude: appointment.provider.office.latitude,
                        longitude: appointment.provider.office.longitude,
                      },
                    ]}
                  />
                  <LegacyPanel px={0} mb={0}>
                    <AppointmentInfo appointment={appointment} large useMainLayout />
                  </LegacyPanel>
                </div>
              </div>
            </MainLayout>
          );
        }}
      </Query>
    );
  }
}

export default createSchedulingSessionStateLandingPage(AppointmentDetailPage);
